const LCP_THRESHOLD_GOOD = 2.5;
const LCP_THRESHOLD_NEEDS_IMPROVEMENT = 4;
const FCP_THRESHOLD_GOOD = 1.8;
const FCP_THRESHOLD_NEEDS_IMPROVEMENT = 3;
const THRESHOLDS = {
  lcp: {
    good: LCP_THRESHOLD_GOOD,
    needsImprovement: LCP_THRESHOLD_NEEDS_IMPROVEMENT,
    poor: LCP_THRESHOLD_NEEDS_IMPROVEMENT
  },
  fcp: {
    good: FCP_THRESHOLD_GOOD,
    needsImprovement: FCP_THRESHOLD_NEEDS_IMPROVEMENT,
    poor: FCP_THRESHOLD_NEEDS_IMPROVEMENT
  }
};
const isLCPGood = (lcpSeconds) => lcpSeconds <= LCP_THRESHOLD_GOOD;
const isFCPGood = (fcpSeconds) => fcpSeconds <= FCP_THRESHOLD_GOOD;
const getLCPRating = (lcpSeconds) => {
  if (lcpSeconds <= LCP_THRESHOLD_GOOD) return "good";
  if (lcpSeconds <= LCP_THRESHOLD_NEEDS_IMPROVEMENT) return "needs-improvement";
  return "poor";
};
const getFCPRating = (fcpSeconds) => {
  if (fcpSeconds <= FCP_THRESHOLD_GOOD) return "good";
  if (fcpSeconds <= FCP_THRESHOLD_NEEDS_IMPROVEMENT) return "needs-improvement";
  return "poor";
};
const msToSeconds = (ms) => ms / 1e3;
const secondsToMs = (seconds) => seconds * 1e3;
export {
  FCP_THRESHOLD_GOOD,
  FCP_THRESHOLD_NEEDS_IMPROVEMENT,
  LCP_THRESHOLD_GOOD,
  LCP_THRESHOLD_NEEDS_IMPROVEMENT,
  THRESHOLDS,
  getFCPRating,
  getLCPRating,
  isFCPGood,
  isLCPGood,
  msToSeconds,
  secondsToMs
};
//# sourceMappingURL=thresholds.js.map
